function MenuIcon()
{
    return(
        <svg id="Layer_3" data-name="Layer 3" viewBox="0 0 128 128"><path d="M97.092,36.078H30.908a2.111,2.111,0,0,0,0,4.222H97.092a2.111,2.111,0,0,0,0-4.222Z"/><path d="M97.092,61.889H30.908a2.111,2.111,0,0,0,0,4.222H97.092a2.111,2.111,0,0,0,0-4.222Z"/><path d="M97.092,87.7H30.908a2.111,2.111,0,0,0,0,4.222H97.092a2.111,2.111,0,0,0,0-4.222Z"/></svg>
    )
}

export default MenuIcon